export const distanceBetweenTwoLatLngsInPx = (map, latlng1, latlng2) => {
  if (!map || !latlng1 || !latlng2) {
    return null
  }

  const p1 = map.latLngToLayerPoint(latlng1)
  const p2 = map.latLngToLayerPoint(latlng2)

  return Math.sqrt((p2.x - p1.x) ** 2 + (p2.y - p1.y) ** 2)  // Pythagoras
}



// WEBPACK FOOTER //
// ./src/components/Leaflet/LeafletTools.js